<template>
  <section class="hbox stretch">
    <div class="content-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>运营</el-breadcrumb-item>
        <el-breadcrumb-item>轮播广告</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-main">
      <el-form :inline="true">
        <el-form-item>
          <el-button type="primary" class="el-icon-circle-plus-outline" v-on:click="AddAdvert" >新增</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="adverts" style="width: 100%">
        <el-table-column  prop="href"  label="路径"> </el-table-column>
        <el-table-column label="图片" prop="imageSrc" :show-overflow-tooltip = "true">
          <template slot-scope="scope" inline-template>
            <img :src="scope.row.imageSrc"  min-width="40" height="30"/>
          </template>
        </el-table-column>
        <el-table-column  label="操作" width="120">
          <template slot-scope="scope">
            <!-- <el-button @click.native.prevent="editRow(scope.row)" type="text" size="small">
              编辑
            </el-button> -->
            <el-button @click.native.prevent="deleteRow(scope.$index)" type="text" size="small">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="广告设置" width="450px" :visible.sync="dialogFormVisible">
        <el-form ref="form" :model="advert" label-width="80px">            
          <el-form-item label="上传图片">
            <el-col :span="12">
              <el-upload
                class="upload-demo"
                :action="uploadUrl"
                :headers="headers"
                :on-success="handleIconSuccess">
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-col>
          </el-form-item>  
          <el-form-item label="路径">
            <el-col :span="20">
              <el-input v-model="href"></el-input>
            </el-col>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="SaveAdvert" >确 定</el-button>
        </div>
      </el-dialog>
    </div>   
  </section>
</template>
<script  type='text/ecmascript-6'>
  import qs from 'qs' 
  export default {
    props:{
    },
    data (){
      return {
        adverts:[],
        advert:{},
        imageSrc:'',
        href:'',
        dialogFormVisible:false,
        uploadUrl: this.global.serverSrc+'/api/Common/UploadImage',
        headers:{
          Authorization : sessionStorage.getItem('token')
        }
      }
    },
    computed:{
    },
    mounted(){
      this.GetAdverts();
    },
    methods:{       
      AddAdvert:function(){
        this.dialogFormVisible=true
      },
      handleIconSuccess(res, file){
        this.imageSrc = res.fullUrl
        //this.imageUrl = URL.createObjectURL(file.raw);
      },
      GetAdverts:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/System/GetParameterValue',
          params:{
            key : 'Adverts',
          }
        }).then(function (resp) {
          that.adverts = JSON.parse(resp.data.value)
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      SaveAdvert:function(){
        this.advert.imageSrc = this.imageSrc
        this.advert.href = this.href
        this.adverts.push(this.advert)
        this.SubmitAdverts()  
        this.dialogFormVisible= false     
      },
      editRow(row){
        this.advert = row;
        this.dialogFormVisible= true  
      },
      deleteRow(index) {
        this.$confirm('确定要删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {          
          this.adverts.splice(index, 1)
          this.SubmitAdverts()
        }).catch(() => {
            
        });
      },
      SubmitAdverts:function(){
        var that = this
        var dataObj ={
          adverts: JSON.stringify(that.adverts),          
        };
        dataObj = qs.stringify(dataObj)
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/System/SaveParameter', 
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },        
          data:dataObj
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      }
   },
    components:{    
       
    },
    created(){
      
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>